import dayjs from 'dayjs';
import { Fragment } from 'react';
import { DAY_OF_WEEK } from '../../constant';
import * as CommonS from '../../styles';
import { TimelineColumns } from '../../types';
import { getIsSameDate } from '../../utils';
import * as S from './styles';

interface Props {
  columns: TimelineColumns[];
}

export default function HeaderWeekDay({ columns }: Props) {
  const today = dayjs();

  return (
    <S.Root>
      <CommonS.ColTimeHolder />
      {columns.map(({ date, displayText, width }, index) => (
        <Fragment key={index}>
          {displayText ? (
            <CommonS.Col columnWidth={width}>{displayText()}</CommonS.Col>
          ) : (
            <>
              <CommonS.Col key={index}>
                <S.ColDayHeader>
                  <S.HeaderDay isToday={getIsSameDate(today, date)}>
                    {DAY_OF_WEEK[date.get('day')]}
                  </S.HeaderDay>
                  <S.HeaderDate isToday={getIsSameDate(today, date)}>
                    {date.get('dates')}
                  </S.HeaderDate>
                </S.ColDayHeader>
              </CommonS.Col>
            </>
          )}
        </Fragment>
      ))}
    </S.Root>
  );
}
